import Swal from 'sweetalert2'
import { get } from 'svelte/store'
import { lang } from '@/store'
import { i18n } from '@/plugins/util'

export const isNewsfeedFeatureEnabled =
  Boolean(import.meta.env.VITE_API_LOCA_URL)

export function showNewsfeedComingSoon(): void {
  Swal.fire({
    icon: 'info',
    title: i18n(get(lang), ['Newsfeed under maintenance', 'ລະບົບຂ່າວສານກຳລັງປັບປຸງ']),
    text: i18n(
      get(lang),
      [
        'This service is temporarily unavailable. Please try again later.',
        'ບໍລິການນີ້ບໍ່ພ້ອມໃຊ້ງານຊົ່ວຄາວ. ກະລຸນາລອງໃໝ່ອີກພາຍຫຼັງ.',
      ],
    ),
    confirmButtonColor: '#1CAAFC',
  })
}
